/**
 * OCHAT OVERLAY: en overrides, spread into one flat namespace map,
 * mirroring how upstream's locale/<locale>/index.js is built.
 *
 * Each file holds ONLY the keys where Ochat differs from upstream, so a diff
 * here reads as "what Ochat changed" instead of a whole retranslated locale.
 * See ../index.js for how these get merged in.
 */
import advancedFilters from './advancedFilters.json';
import bookings from './bookings.json';
import conversation from './conversation.json';
import guide from './guide.json';
import integrations from './integrations.json';
import marketing from './marketing.json';
import settings from './settings.json';
import signup from './signup.json';

export default {
  ...advancedFilters,
  ...bookings,
  ...conversation,
  ...guide,
  ...integrations,
  ...marketing,
  ...settings,
  ...signup,
};
